import { __rest } from "tslib";
import * as React from 'react';
// tslint:disable-next-line:import-blacklist
import { Redirect } from 'react-router-dom';
import { useConfig } from '../../../../context';
import { mapRoutePath } from '../lib/mapRoutePath';
export const RedirectWrapper = (_a) => {
    var _b;
    var { to, from } = _a, rest = __rest(_a, ["to", "from"]);
    const enabled = (_b = useConfig().global.alternativeRouting) !== null && _b !== void 0 ? _b : false;
    const wrappedTo = typeof to === 'string'
        ? mapRoutePath(to, enabled)
        : to && typeof to === 'object' && typeof to.pathname === 'string'
            ? Object.assign(Object.assign({}, to), { pathname: mapRoutePath(to.pathname, enabled) }) : to;
    const wrappedFrom = typeof from === 'string' ? mapRoutePath(from, enabled) : from;
    return React.createElement(Redirect, Object.assign({ to: wrappedTo, from: wrappedFrom }, rest));
};
